import { Loader2 } from "lucide-react";
import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Card, Button, Label, TextInput } from "flowbite-react";


import { COMPANY, ME } from "../../lib/urls";
import { useStore } from "../../store";

const Company = () => {
  const navigate = useNavigate();

  const [domain, setDomain] = useState("");
  const [slug, setSlug] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [loading, setLoading] = useState(false);

  const userId = useStore((state) => state.uid);
  const token = useStore((state) => state.token);
  const setUser = useStore((state) => state.setUser);
  const setCompany = useStore((state) => state.setCompany);
  const setOnboardingRequired = useStore(
    (state) => state.setOnboardingRequired
  );

  const handleSubmit = async (e) => {
    setLoading(true);
    try {
      const r = await fetch(COMPANY, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: companyName,
          description: "",
          company_domain: domain,
          slug: slug,
          created_by_id: userId,
        }),
      });

      if (!r.ok) {
        throw new Error((await r.json())?.detail);
      }
      await fetchMe(token);
      setOnboardingRequired(false);
      toast.success("User created successfully");

      setTimeout(() => {
        navigate("/jobs");
      }, 1000);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchMe = async (token) => {
    try {
      const response = await fetch(ME, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const {
          user: { id, ...data },
          company,
          onboarding_required,
        } = await response.json();

        setUser(data);
        setCompany(company);
        setOnboardingRequired(onboarding_required);
        return data;
      }
    } catch (error) {
      console.error("Error fetching me:", error);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <Card className="w-full max-w-2xl p-6">
        <h1
          className="text-h5 mb-4"
        >
          Create Organization
        </h1>
        <p className="mb-6">
          <strong>Welcome to June!</strong> June is your AI Interviewer,
          designed to streamline and enhance your hiring process by making
          candidate screening faster and more efficient. Create your
          Organization account below.
        </p>
        <form>
          <div className="mb-4">
            <Label htmlFor="organizationName" value="Organization Name" />
            <div className="mb-1"></div>
            <TextInput
              id="organizationName"
              name="organizationName"
              type="text"
              placeholder="Organization Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <Label htmlFor="slugName" value="Slug Name" />
            <div className="mb-1"></div>
            <TextInput
              id="slugName"
              name="slugName"
              type="text"
              placeholder="Slug Name"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              required
            />
          </div>
          <div className="mb-4">
            <Label htmlFor="websiteURL" value="Website URL" />
            <div className="mb-1"></div>
            <TextInput
              id="websiteURL"
              name="websiteURL"
              type="text"
              placeholder="Company domain"
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
            />
          </div>

          <div className="flex justify-end gap-3">
            <Button
              as={Link}
              to="/"
              className="bg-transparent text-primary border-primary"
            >
              Back
            </Button>

            <Button
              className="bg-primary flex justify-center items-center"
              onClick={handleSubmit}
              data-cy="create-organization-button"
            >
              Create Organization
              {loading && <Loader2 size="1em" className="animate-spin ml-2" />}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default Company;
